module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-whitespace-FAT.js";